module.exports = __webpack_public_path__ + "static/img/intention.9b5fe56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intention.png
// module id = ICZe
// module chunks = 29